import { ASSETS_BASE_URL } from './AssetBaseUrlConstants'

const BASE_PREFIX_URL = `${ASSETS_BASE_URL}/customer-portal`

export const PORTAL_MAP_IMG_URL = `${ASSETS_BASE_URL}/customer-portal/portal-login-cm-bg-v4.png`

export const MAP_WITH_CM_MEDIUM_IMG_URL = `${ASSETS_BASE_URL}/customer-portal/portal-login-cm-bg-v5.png`

export const PORTAL_RIGHT_SIDE_BG_IMG = `${BASE_PREFIX_URL}/portals-login-right-bg.png`
